(function () {
  function bindSingleOpen(section) {
    if (section.dataset.faqV2SingleOpen !== 'true') return;

    section.addEventListener(
      'toggle',
      (event) => {
        const item = event.target;
        if (!item.classList.contains('faq-v2__item') || !item.open) return;

        const panel = item.closest('[data-faq-panel]');
        const scope = panel || section;
        scope.querySelectorAll('.faq-v2__item').forEach((other) => {
          if (other !== item) other.open = false;
        });
      },
      true
    );
  }

  function bindCategories(section) {
    const tabs = section.querySelectorAll('[data-faq-category-tab]');
    const panels = section.querySelectorAll('[data-faq-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const category = tab.getAttribute('data-faq-category-tab');
        if (!category) return;

        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.getAttribute('data-faq-panel') === category;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function initSection(section) {
    if (section.dataset.faqV2Inited === 'true') return;
    section.dataset.faqV2Inited = 'true';

    bindCategories(section);
    bindSingleOpen(section);
  }

  function boot() {
    document.querySelectorAll('[data-faq-v2]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-faq-v2]').forEach(initSection);
  });
})();
